import * as React from "react";

function IconArrow(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 32 33"
            {...props}
        >
            <path
                d="M3.692 11.74L14.64 1h2.72l10.948 10.74v6.035L18.177 7.734V33h-4.354V7.734L3.692 17.775z"
                fill="currentColor"
                fillRule="evenodd"
                style={props.style}
            />
        </svg>
    );
}

export default IconArrow;
